/*
  BELANTTI — QUICK BUY / CART RESTORE
  Version: v2.2
  Purpose:
  - Does not open the old legacy minicart
  - Does not hijack the PDP custom drawer
  - Stops collection/grid add-to-cart redirects
  - Opens the existing Belantti drawer when it exists on the page
*/

(function () {
  if (window.BELANTTI_QUICK_BUY_CART_RESTORE_V22) return;
  window.BELANTTI_QUICK_BUY_CART_RESTORE_V22 = true;

  var FREE_DELIVERY_TARGET = 3500;

  function moneyFromPence(pence) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.money_format) {
      try {
        return Shopify.formatMoney(pence, window.money_format);
      } catch (e) {}
    }

    return '£' + (Number(pence || 0) / 100).toFixed(2);
  }

  function isCartAddForm(form) {
    if (!form || !form.getAttribute) return false;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  function isPDPForm(form) {
    if (!form) return false;

    return (
      form.id === 'AddToCartForm' ||
      form.closest('.bel-pdp-clean') ||
      form.querySelector('.bel-pdp-main-atc')
    );
  }

  function updateCounters(cart) {
    var count = cart && typeof cart.item_count !== 'undefined' ? cart.item_count : 0;

    document.querySelectorAll(
      '[data-cart-count], .enj-cartcount, .js-number-cart, .cart-counter, .count_pr_incart, .number-cart, .js-cart-count, .header-cart-count, .js-cart-count-bubble'
    ).forEach(function (el) {
      el.textContent = count;

      if (count > 0) {
        el.style.display = '';
        el.classList.add('active');
      } else {
        el.classList.remove('active');
      }
    });

    document.querySelectorAll('.js-call-minicart').forEach(function (el) {
      el.setAttribute('aria-label', 'Open basket, ' + count + ' items');
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not load basket');
        return response.json();
      })
      .then(function (cart) {
        updateCounters(cart);
        return cart;
      });
  }

  function setButton(btn, state) {
    if (!btn) return;

    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent.trim() || 'Add to Basket';
    }

    if (state === 'loading') {
      btn.textContent = 'Adding…';
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      return;
    }

    if (state === 'added') {
      btn.textContent = 'Added ✓';
      btn.removeAttribute('aria-busy');
      btn.disabled = true;
      return;
    }

    btn.textContent = btn.dataset.originalText || 'Add to Basket';
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
  }

  function getDeliveryState(cart) {
    var freeDeliveryHandles = {
      'advanced-exfoliating-foot-mask-single': 1,
      'advanced-98-snail-mucin-serum-100ml': 1,
      'benjamin-button-collagen-powder-bovine-400g': 1,
      'collagen-face-mask': 1,
      '5-pack-collagen-hydrating-face-mask': 1,
      'marine-collagen-powder-400g': 1,
      'marine-collagen-sachets-12-000mg-benjamin-button': 1,
      'marine-collagen-sachets-mango-benjamin-button': 1,
      'benjamin-button-marine-collagen-sachets-orange': 1,
      'exfoliating-foot-mask-5-pack': 1
    };
    var standardSubtotal = 0;
    var hasFreeDeliveryItem = false;
    var hasStandardDeliveryItem = false;

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var handle = item.handle || (((item.url || '').match(/\/products\/([^?]+)/) || [])[1] || '');
      var vendor = String(item.vendor || '').trim().toLowerCase();
      var isFreeDelivery = vendor === 'benjamin button' || Boolean(freeDeliveryHandles[handle]);

      if (isFreeDelivery) {
        hasFreeDeliveryItem = true;
      } else {
        hasStandardDeliveryItem = true;
        standardSubtotal += Number(
          item.final_line_price != null ? item.final_line_price : (item.line_price || 0)
        );
      }
    });

    return {
      hasFreeDeliveryItem: hasFreeDeliveryItem,
      hasStandardDeliveryItem: hasStandardDeliveryItem,
      allFreeDelivery: hasFreeDeliveryItem && !hasStandardDeliveryItem,
      standardSubtotal: standardSubtotal
    };
  }

  function updateExistingBelanttiDrawer(item, cart) {
    var drawer = document.querySelector('[data-bel-atc-drawer]');
    var overlay = document.querySelector('[data-bel-atc-overlay]');

    if (!drawer) return false;

    var titleEl = document.querySelector('[data-bel-atc-title]');
    var qtyEl = document.querySelector('[data-bel-atc-qty]');
    var priceEl = document.querySelector('[data-bel-atc-price]');
    var imageEl = document.querySelector('[data-bel-atc-image]');
    var subtotalEl = document.querySelector('[data-bel-atc-subtotal]');
    var countEl = document.querySelector('[data-bel-atc-count]');
    var progressCopyEl = document.querySelector('[data-bel-atc-progress-copy]');
    var progressNoteEl = document.querySelector('[data-bel-atc-progress-note]');
    var progressFillEl = document.querySelector('[data-bel-atc-progress-fill]');
    var trustDeliveryEl = document.querySelector('[data-bel-atc-trust-delivery]');

    if (item) {
      if (titleEl) titleEl.textContent = item.product_title || item.title || 'Product added';
      if (qtyEl) qtyEl.textContent = 'Quantity: ' + (item.quantity || 1);
      if (priceEl) priceEl.textContent = moneyFromPence(item.final_price || item.price || 0);

      if (imageEl) {
        var imageUrl = '';

        if (item.featured_image && item.featured_image.url) {
          imageUrl = item.featured_image.url;
        } else if (item.image) {
          imageUrl = item.image;
        }

        if (imageUrl) {
          imageEl.src = imageUrl;
          imageEl.alt = item.product_title || item.title || 'Product added';
        }
      }
    }

    if (cart) {
      var state = getDeliveryState(cart);
      var subtotal = cart.total_price || 0;
      var remaining = Math.max(FREE_DELIVERY_TARGET - state.standardSubtotal, 0);
      var progress = state.allFreeDelivery
        ? 100
        : (state.standardSubtotal >= FREE_DELIVERY_TARGET
          ? 100
          : Math.min((state.standardSubtotal / FREE_DELIVERY_TARGET) * 100, 100));

      if (subtotalEl) subtotalEl.textContent = moneyFromPence(subtotal);
      if (countEl) countEl.textContent = cart.item_count || 0;

      if (state.allFreeDelivery) {
        if (progressCopyEl) progressCopyEl.innerHTML = '<strong>Free UK delivery included</strong>';
        if (progressNoteEl) progressNoteEl.textContent = 'No minimum spend required';
        if (progressFillEl) progressFillEl.style.width = '100%';
        if (trustDeliveryEl) trustDeliveryEl.textContent = 'Free UK delivery included';
      } else {
        if (progressCopyEl) {
          if (remaining > 0) {
            progressCopyEl.innerHTML = state.hasFreeDeliveryItem
              ? 'You’re <strong>' + moneyFromPence(remaining) + '</strong> away from free standard delivery on your other items'
              : 'You’re <strong>' + moneyFromPence(remaining) + '</strong> away from free UK delivery';
          } else {
            progressCopyEl.innerHTML = 'You’ve unlocked <strong>free UK delivery</strong>';
          }
        }

        if (progressNoteEl) {
          if (remaining <= 0) progressNoteEl.textContent = 'Free delivery unlocked';
          else if (state.hasFreeDeliveryItem) progressNoteEl.textContent = 'Benjamin Button items already ship free';
          else progressNoteEl.textContent = 'Add more to unlock free delivery';
        }

        if (progressFillEl) progressFillEl.style.width = progress + '%';
        if (trustDeliveryEl) {
          trustDeliveryEl.textContent = state.hasFreeDeliveryItem
            ? 'Free delivery included on Benjamin Button items'
            : 'Free UK delivery from £35';
        }
      }
    }

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');

    if (overlay) {
      overlay.classList.add('is-open');
    }

    document.body.classList.add('bel-atc-lock');

    return true;
  }

  function afterAdd(item) {
    return fetchCart()
      .then(function (cart) {
        var openedDrawer = updateExistingBelanttiDrawer(item, cart);

        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: {
            cart: cart,
            item: item
          }
        }));

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: cart,
            item: item
          }
        }));

        document.dispatchEvent(new CustomEvent('belantti:cart:updated', {
          detail: {
            cart: cart,
            item: item,
            openedDrawer: openedDrawer
          }
        }));

        return cart;
      });
  }

  function addForm(form, btn) {
    if (!form || form.dataset.belSubmitting === 'true') return;

    form.dataset.belSubmitting = 'true';
    setButton(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      body: new FormData(form),
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw errorData;
          });
        }

        return response.json();
      })
      .then(function (item) {
        return afterAdd(item);
      })
      .then(function () {
        setButton(btn, 'added');

        setTimeout(function () {
          setButton(btn, 'reset');
        }, 900);
      })
      .catch(function (error) {
        console.error('Belantti add-to-cart error:', error);
        alert(error && error.description ? error.description : 'Unable to add this item to your basket.');
        setButton(btn, 'reset');
      })
      .finally(function () {
        form.dataset.belSubmitting = 'false';
      });
  }

  function addVariant(btn, variantId) {
    if (!btn || !variantId || btn.dataset.belSubmitting === 'true') return;

    btn.dataset.belSubmitting = 'true';
    setButton(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (errorData) {
            throw errorData;
          });
        }

        return response.json();
      })
      .then(function (item) {
        return afterAdd(item);
      })
      .then(function () {
        setButton(btn, 'added');

        setTimeout(function () {
          setButton(btn, 'reset');
        }, 900);
      })
      .catch(function (error) {
        console.error('Belantti quick-buy error:', error);
        alert(error && error.description ? error.description : 'Unable to add this item to your basket.');
        setButton(btn, 'reset');
      })
      .finally(function () {
        btn.dataset.belSubmitting = 'false';
      });
  }

  document.addEventListener('click', function (event) {
    var quickBtn = event.target.closest('.bel-quick-buy');

    if (!quickBtn) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var card = quickBtn.closest('.bel-product-card, .product, .product-item, .bel-grid-card');
    var hasVariants = quickBtn.dataset.hasVariants === 'true';

    if (hasVariants) {
      var link = card ? card.querySelector('.bel-card-image, a[href*="/products/"]') : null;

      if (link && link.href) {
        window.location.href = link.href;
      }

      return;
    }

    var variantId = quickBtn.dataset.variantId;

    if (!variantId) {
      console.warn('Belantti quick-buy missing variant ID');
      return;
    }

    addVariant(quickBtn, variantId);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!isCartAddForm(form)) return;

    /*
      Important:
      Do NOT intercept the Belantti PDP form.
      product-extended.liquid already has the correct custom drawer logic.
    */
    if (isPDPForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var btn = event.submitter || form.querySelector(
      'button[type="submit"], button[name="add"], input[type="submit"], .addcart-link, .btn-addToCart, .btn-addtocart, .add-to-cart, .bel-grid-atc-btn'
    );

    addForm(form, btn);
  }, true);

  document.addEventListener('click', function (event) {
    var btn = event.target.closest(
      '.addcart-link, .btn-addToCart, .btn-addtocart, .add-to-cart, .bel-grid-atc-btn, button[name="add"], input[name="add"]'
    );

    if (!btn || btn.classList.contains('bel-quick-buy')) return;

    var form = btn.closest('form');

    if (!isCartAddForm(form)) return;

    /*
      Important:
      Leave the PDP button alone so the existing custom drawer opens.
    */
    if (isPDPForm(form)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    addForm(form, btn);
  }, true);

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('[data-bel-atc-close], [data-bel-atc-continue]');
    if (!closeBtn) return;

    var drawer = document.querySelector('[data-bel-atc-drawer]');
    var overlay = document.querySelector('[data-bel-atc-overlay]');

    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (overlay) {
      overlay.classList.remove('is-open');
    }

    document.body.classList.remove('bel-atc-lock');
  }, true);

})();